import { render } from "./ProjectSearch.vue?vue&type=template&id=3f6f0e59"
import script from "./ProjectSearch.vue?vue&type=script&lang=js"
export * from "./ProjectSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__